import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../images/logo.png";

const sectionLinks = ["home", "services", "about", "contact"];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSectionNav = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
    setMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-slate-200/70 bg-white/80 shadow-sm backdrop-blur-xl">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <button
          type="button"
          className="flex items-center gap-3"
          onClick={() => {
            navigate("/");
            setMenuOpen(false);
          }}
        >
          <div className="h-14 w-14 rounded-3xl p-3">
            <img src={logo} alt="Nexora Ventures logo" className="h-full w-full object-contain" />
          </div>
          <div className="text-left">
            <p className="text-sm font-bold text-slate-900">Nexora Ventures</p>
            <p className="text-xs text-slate-500">Digital innovation studio</p>
          </div>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          <ul className="flex items-center gap-8">
            {sectionLinks.map((item) => (
              <li key={item}>
                <button
                  onClick={() => handleSectionNav(item)}
                  className="capitalize font-medium text-gray-600 transition-colors hover:text-blue-600"
                >
                  {item}
                </button>
              </li>
            ))}
            <li>
              <Link
                to="/pricing"
                className="font-medium text-gray-600 transition-colors hover:text-blue-600"
              >
                Pricing
              </Link>
            </li>
          </ul>

          <button
            onClick={() => handleSectionNav("contact")}
            className="rounded-lg bg-blue-600 px-5 py-2 font-medium text-white transition-colors hover:bg-blue-700"
          >
            Get a Quote
          </button>
        </div>

        <button
          aria-label="Toggle navigation menu"
          className="flex flex-col gap-1.5 p-2 transition-transform hover:-translate-y-0.5 md:hidden"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className={`block h-0.5 w-6 bg-slate-700 transition-all ${menuOpen ? "translate-y-2 rotate-45" : ""}`} />
          <span className={`block h-0.5 w-6 bg-slate-700 transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-6 bg-slate-700 transition-all ${menuOpen ? "-translate-y-2 -rotate-45" : ""}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="flex flex-col gap-4 border-t border-gray-100 bg-white px-6 py-4 md:hidden">
          {sectionLinks.map((item) => (
            <button
              key={item}
              onClick={() => handleSectionNav(item)}
              className="border-b border-gray-50 py-2 text-left font-medium capitalize text-gray-700"
            >
              {item}
            </button>
          ))}

          <Link
            to="/pricing"
            onClick={() => setMenuOpen(false)}
            className="border-b border-gray-50 py-2 font-medium text-gray-700"
          >
            Pricing
          </Link>

          <button
            onClick={() => handleSectionNav("contact")}
            className="rounded-lg bg-blue-600 py-2 font-medium text-white"
          >
            Get a Quote
          </button>
        </div>
      )}
    </nav>
  );
}
